export const SECOND = 1000
export const TYPING_TIMEOUT = 3000 // 3 seconds
export const BOT_TYPING_TIMEOUT = 10000 // 10 seconds
